import mitt from 'mitt'

import { HttpServerStatus } from '@shared/models/enums/http'
import { ChatSubTabs } from '@shared/models/enums/tabs'
import { AttachTracksEvent } from '@shared/models/interfaces/conversations'

import { ActionsNode } from '@bd/models/enums'
import { SelfSchedulerInputIds } from '@pc/models/common/interfaces/scheduler-input-ids'
import { VisitPathShowOnMapEvent } from '@vp/models/events'

export enum GlobalEvents {
  AsyncRequestProgress = 'global-events/on-async-request-progress',
  DocumentVisibilityChanged = 'global-events/document-visibility-changed',
  UnAuthenticated = 'global-events/on-log-out',
  RenewSuccess = 'global-events/session-renew-success',
  ResetInputField = 'global-events/reset-input-field',
  FocusInput = 'globale-events/focus-input',
  ServerError = 'globale-events/server-error',
}

export enum VideoCallEvents {
  AttachTracks = 'video-call-events/on-attach-tracks',
  RedirectToConversation = 'video-call-events/redirect-to-conversation',
  HangUp = 'video-call-events/hang-up',
}

export enum VirtualConversationsEvents {
  ExpandConversationSubtab = 'virtual-conversations/expand-subtab',
  Navigate = 'virtual-conversations/navigate',
  OpenBotQuickFormModal = 'virtual-conversations/open-bot-quick-form',
  OpenSelfSchedulerDialog = 'virtual-conversations/open-self-scheduler',
  FindUnreadMessage = 'virtual-conversations/find-unread-message',
}

export enum VisitPathEvents {
  ShowOnMap = 'visit-path/show-on-map',
}

export enum SelfScheduleEvents {
  submitLocation = 'self-schedule/submit-location',
  submitCalendar = 'self-schedule/submit-calendar',
  submitApi = 'self-schedule/submit-api',
}

export enum BotDesignerEvents {
  saveTranslations = 'bot-designer/save-translations',
  translateMessages = 'bot-designer/translate-messages',
  inputUpdateTranslations = 'bot-designer/input-update-translations',
  updateNodes = 'bot-designer/update-nodes',
  openACTestPreview = 'bot-designer/open-ac-test-preview',
  openSymptomCheckerSettings = 'bot-designer/open-symtom-checker-settings',
  selectNode = 'bot-designer/select-node',
}

export enum MessageSequenceEvent {
  resetView = 'message-sequence/reset-view',
}

export enum PatientChatEvents {
  redirectToTac = 'patient-chat/redirect-to-tac',
}

export enum QuickSignEvents {
  saveQuickSignDocument = 'quick-sign/save-quick-sign-document',
  validationError = 'quick-sign/save-quick-validation-error',
  saveSignaturesToPreferences = 'quick-sign/save-quick-sign-signatures',
  saveQuickSignAsTemplate = 'quick-sign/save-quick-sign-as-template',
}

type Events = {
  [GlobalEvents.AsyncRequestProgress]: {
    total?: number
    loaded: number
  }
  [GlobalEvents.DocumentVisibilityChanged]: boolean
  [GlobalEvents.RenewSuccess]: undefined
  [GlobalEvents.UnAuthenticated]: undefined
  [GlobalEvents.ResetInputField]: undefined
  [GlobalEvents.FocusInput]: boolean
  [GlobalEvents.ServerError]: HttpServerStatus
  [VideoCallEvents.AttachTracks]: AttachTracksEvent
  [VideoCallEvents.RedirectToConversation]: undefined
  [VideoCallEvents.HangUp]: undefined
  [VirtualConversationsEvents.ExpandConversationSubtab]: ChatSubTabs
  [VirtualConversationsEvents.OpenSelfSchedulerDialog]: SelfSchedulerInputIds
  [VirtualConversationsEvents.FindUnreadMessage]: number
  [VirtualConversationsEvents.OpenSelfSchedulerDialog]: SelfSchedulerInputIds
  [VisitPathEvents.ShowOnMap]: VisitPathShowOnMapEvent
  [SelfScheduleEvents.submitLocation]: void
  [SelfScheduleEvents.submitCalendar]: void
  [SelfScheduleEvents.submitApi]: void
  [BotDesignerEvents.saveTranslations]: void
  [BotDesignerEvents.translateMessages]: void
  [BotDesignerEvents.inputUpdateTranslations]: void
  [BotDesignerEvents.updateNodes]: void
  [BotDesignerEvents.openACTestPreview]: void
  [BotDesignerEvents.openSymptomCheckerSettings]: string
  [BotDesignerEvents.selectNode]: { uuid: string; action: ActionsNode }
  [MessageSequenceEvent.resetView]: undefined
  [PatientChatEvents.redirectToTac]: undefined
  [QuickSignEvents.saveQuickSignDocument]: {
    annotations: string
    fileData: File
  }
  [QuickSignEvents.validationError]: {
    value: string
  }
  [QuickSignEvents.saveSignaturesToPreferences]: Array<string>
  [QuickSignEvents.saveQuickSignAsTemplate]: {
    annotations: string
    fileData: File
  }
}

const bus = mitt<Events>()

export default bus
